/**
 * Words put before a name without being part of it: a correction ("Actually,",
 * "No,"), an emphasis ("only", "just"), an instruction ("make it"), or what
 * introduces who or what it's about ("for", "to", "the"). Stripped from the
 * start of a reply before it's matched against a real name, repeatedly, so
 * "Actually, only Grade 3" is "Grade 3" and "Only for Grade 2" is "Grade 2".
 */
const LEAD_IN_WORDS = ["oh", "wait", "sorry", "ok", "okay", "actually", "only", "just", "make it", "no", "for", "to", "the"];

const pattern = LEAD_IN_WORDS.map((w) => w.replace(/\s+/g, "\\s+")).join("|");
const AT_START = new RegExp(`^(?:${pattern})\\b[\\s,]*`, "i");

/**
 * What's typed without lead-in words at the start: never the whole text when
 * it's nothing but lead-in words, which is why an empty result is possible.
 */
export function stripLeadIn(text: string): string {
  let trimmed = text.trim();
  for (let before = ""; before !== trimmed; ) {
    before = trimmed;
    trimmed = trimmed.replace(AT_START, "").trim();
  }
  return trimmed;
}
